import { useAppConfig } from '@msrceng/auth';
import { MessageApiDown } from '@msrceng/component';

/** Down for maintenance banner hooked up to SUG API */
export const SugDownForMaintenance = () => {
  const { apiRoot } = useAppConfig();

  return <MessageApiDown apiList={[`${apiRoot}/sug/v2.0/status`]} />;
};
